namespace $.$$ {

	$mol_style_define( $shm_hitalama_process_monitor, {

		maxWidth: '100%',
		overflow: 'hidden',

		Page: {
			width: 'stretch' as any,
			flex: {
				shrink: 1,
				grow: 1,
			},
		},

		Menu: {
			flex: {
				basis: '24rem',
			},

			Body_content: {
				gap: '0.5rem',
			},
		},

		Menu_filter: {
			width: 'stretch' as any,
		},

		Menu_tools: {
			display: 'flex',
			align: {
				items: 'center',
			},
			gap: $mol_gap.text,
		},

		Menu_item: {
			align: {
				items: 'center',
			},
			gap: 0,
			flex: {
				wrap: 'nowrap',
				shrink: 1,
			},
			overflow: 'hidden',
			border: {
				radius: $mol_gap.round,
			},
			'@': {
				shm_hitalama_process_monitor_current: {
					true: {
						background: {
							color: $mol_theme.card,
						},
					},
				},
			},
		},

		Menu_detail: {
			padding: 0,
			minWidth: 0,
			minHeight: 0,
			height: 'stretch' as any,
			flex: {
				shrink: 0,
			},
		},

		Menu_widget: {
			align: {
				items: 'center',
			},
			gap: $mol_gap.text,
			flex: {
				grow: 1,
				shrink: 1,
				wrap: 'nowrap',
			},
			overflow: 'hidden',
			justify: {
				content: 'flex-start',
			},
		},

		Exclude_filter: {
			flex: {
				shrink: 0,
			},
		},

		Exclude_label: {
			padding: {
				bottom: $mol_gap.text,
			},
			font: {
				weight: 600,
			},
		},

		Exclude_input: {
			width: '100%',
		},

		Process_duration: {
			width: '4rem',
			padding: {
				left: '0.25rem',
			},
			height: 'stretch' as any,
			color: $mol_theme.shade,
			font: {
				family: 'monospace',
			},
			flex: {
				shrink: 0,
			},
			justify: {
				content: 'center'
			},
			align: {
				items: 'center',
			},
		},

		Menu_link_status: {
			padding: {
				top: '.15rem',
				bottom: '.15rem',
				left: '.45rem',
				right: '.45rem',
			},
			border: {
				radius: $mol_gap.round,
			},
			background: {
				color: $mol_theme.line,
			},
			font: {
				size: '.75rem',
				weight: 600,
			},
			textTransform: 'uppercase',
			flex: {
				shrink: 0,
			},
		},

		Menu_link_title: {
			width: '100%',
			minWidth: 0,
			flex: {
				grow: 1,
				shrink: 1,
			},
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'normal',
		},

		Menu_node_branch: {
			Trigger: {
				flex: {
					grow: 0,
				},
			},
			Content: {
				margin: {
					left: '1rem',
				},
				border: {
					left: {
						style: 'solid',
						width: '1px',
						color: $mol_theme.line,
					},
					top: {
						style: 'solid',
						width: '1px',
						color: $mol_theme.line,
					},
				},
			},
		},

	} )

}
